import { createSelector } from "reselect";

import { ApplicationScope } from "@superblocksteam/shared";

import type { AppState } from "store/types";

const getTimers = (state: AppState) => state.application.timers;

export const getAllTimers = createSelector([getTimers], (timers) => {
  return {
    ...timers[ApplicationScope.PAGE],
    ...timers[ApplicationScope.APP],
  };
});

export const getScopedTimers = createSelector(
  [getTimers, (_, scope: ApplicationScope) => scope],
  (timers, scope) => timers[scope],
);

export const getAllTimerNames = createSelector([getAllTimers], (timers) =>
  Object.values(timers).map((timer) => timer.name),
);

export const getScopedTimerNames = (state: AppState, scope: ApplicationScope) =>
  Object.values(getScopedTimers(state, scope)).map((timer) => timer.name);
